import React from 'react'
import './Page404.css' // Optional: import your custom CSS

const Page404 = () => {
  return (
    <div className="page404-wrapper">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="message-section">
              <h1 className="display-number">404</h1>
              <div className="message-text">
                <h4>Oops! You're lost.</h4>
                <p>The page you are looking for was not found.</p>
              </div>
            </div>
            <div className="search-group">
              <span className="search-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001l3.85 3.85a1 1 0 0 0 1.415-1.415l-3.85-3.85zm-5.742.656a5 5 0 1 1 0-10 5 5 0 0 1 0 10z" />
                </svg>
              </span>
              <input
                type="text"
                className="search-input"
                placeholder="What are you looking for?"
              />
              <button className="search-button">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page404
